import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { ICreateScimConfigRequest, ICreateScimConfigResponse, IScimConfig } from '../service/ScimConfigService';

export function createScimConfigRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.27',
    httpMethod: 'POST',
    endpoint: `scimConfig`,
    serverWideRequest: false
  };
}

export function callCreateScimConfigRequest(scimConfig: IScimConfig): Promise<ICreateScimConfigResponse> {
  return makeJsonRestApiRequest<ICreateScimConfigRequest, ICreateScimConfigResponse>({
    config: createScimConfigRequestConfig(),
    request: {
        createServerScimConfigRequest: {
        mode: scimConfig.mode,
        siteId: scimConfig.siteIds,
      }
    },
  });
}